import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationStart } from '@angular/router';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { SharepromotionalcodeComponent } from '../sharepromotionalcode.component';

export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-sharepromotainal-popup',
  templateUrl: './sharepromotainal-popup.component.html',
  styleUrls: ['./sharepromotainal-popup.component.css'],
  providers: [Modal]
})
export class SharepromotainalPopupComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  constructor(public dialog: DialogRef<CustomModalContext>, private modal: Modal, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.context = dialog.context;
    this.context.dialogClass = 'addeditPopup';
  }

  ngOnInit() {}

  closeClick() {
    if ((this.dialog.context.modalData.page == 'menu')) {
      this.dialog.close();
    } else {
      this.dialog.close();
      this.router.navigate(['/dashboard']);
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/sharepromotionalcode/sharepromotainal-popup/sharepromotainal-popup.component.ts